<template>
  <kanbanWrap>
    <kanbanselectGroup @now="renow"></kanbanselectGroup>

    <abc v-if="now == 1"></abc>
    <feiyong v-if="now == 2"></feiyong>
    <diaodu v-if="now == 3">></diaodu>
    <tangci v-if="now == 4"></tangci>
  </kanbanWrap>
</template>
<script>

import kanbanWrap from "./kanbanWrap.vue";
import kanbanselectGroup from "./kanbanselectGroup.vue";
import abc from "./abc";
import feiyong from "./feiyong";
import diaodu from "./diaodu";
import tangci from "./tangci";
export default {
  components: {
    kanbanWrap,
    kanbanselectGroup, abc, feiyong, diaodu, tangci
  },

  data() {
    return { now: 1 };
  },
  methods: {
    renow(v) {
      this.now=v;
    }
  },
  computed: {},

  mounted() {
    //let screenWidth = window.innerWidth;

  },
};
</script>

<style lang="">
#big {
  width: 1920px;
  height: 1080px;
  padding: 0 16px;
  transform-origin: 0 0;
}
#big p,
#big div {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/index.vue